import { render, staticRenderFns } from "./ParametresDepot.vue?vue&type=template&id=4c4d23a6&scoped=true&"
import script from "./ParametresDepot.vue?vue&type=script&lang=js&"
export * from "./ParametresDepot.vue?vue&type=script&lang=js&"
import style0 from "./ParametresDepot.vue?vue&type=style&index=0&id=4c4d23a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d23a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4d23a6')) {
      api.createRecord('4c4d23a6', component.options)
    } else {
      api.reload('4c4d23a6', component.options)
    }
    module.hot.accept("./ParametresDepot.vue?vue&type=template&id=4c4d23a6&scoped=true&", function () {
      api.rerender('4c4d23a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Divers/ParametresDepot.vue"
export default component.exports